/* SHOPYTHON — rising dots and sparkles behind the content, on every page.

   A fixed canvas sits behind the page (z-index -1). The full-width section
   wrappers are painted the same white as the page, which would hide it, so the
   ones whose colour matches the page background are made transparent; the page
   itself still shows that colour. Cards, product photos, panels, pop-ups,
   drawers and coloured sections keep their backgrounds, so the motes pass behind
   them rather than over them.

   The homepage draws its own motes on the line-art canvas, so this steps aside
   there. */
(function () {
  'use strict';
  if (window.__siteMotes) return;
  window.__siteMotes = true;

  function boot() {
    if (document.querySelector('.la-home')) return;
    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

    var cv = document.createElement('canvas');
    cv.id = 'site-motes';
    cv.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(cv, document.body.firstChild);
    var css = document.createElement('style');
    css.textContent = '#site-motes{position:fixed;inset:0;width:100%;height:100%;z-index:-1;pointer-events:none}' +
                      '.motes-clear{background:transparent!important}';
    document.head.appendChild(css);

    // clear the big wrappers that only repeat the page colour
    var KEEP = 'product-modal, modal-dialog, details, .drawer, .menu-drawer, cart-drawer, .cart-drawer, header, footer, [role="dialog"], ' +
               '.product__media-wrapper, .product-media-container, .media';   // photo frames keep their white
    function clear() {
      var page = getComputedStyle(document.body).backgroundColor;
      var els = document.querySelectorAll('main .gradient, main .sf-page, main .sheet, main section, main [class*="section-template--"]');
      for (var i = 0; i < els.length; i++) {
        var e = els[i], cs = getComputedStyle(e);
        if (e.closest(KEEP) || cs.backgroundImage !== 'none' || cs.backgroundColor !== page) continue;
        if (e.getBoundingClientRect().width < innerWidth * .6) continue;
        e.classList.add('motes-clear');
      }
    }
    clear();
    addEventListener('load', clear);

    var ctx = cv.getContext('2d'), W = 0, H = 0, DPR = 1, motes = [];
    var TAU = Math.PI * 2;
    var INK = [[210,32,45], [210,32,45], [210,32,45], [23,19,15], [150,138,124]];   // mostly brand red
    var hash = function (a, b) { var s = Math.sin(a*127.1 + b*311.7) * 43758.5453; return s - Math.floor(s); };

    function resize() {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = innerWidth; H = innerHeight;
      cv.width = Math.round(W*DPR); cv.height = Math.round(H*DPR);
      var n = W < 720 ? 32 : 66;
      motes = [];
      for (var i = 0; i < n; i++) {
        var r = function (k) { return hash(i + 1, k); };
        motes.push({ i: i, dur: 9 + r(1)*8, off: r(2)*40, star: r(3) < .3, size: r(4), c: INK[(r(5)*INK.length)|0],
                     drift: (r(6) - .5)*90, p: .08 + r(7)*.22, ph: r(8)*TAU });
      }
    }
    function sparkle(x, y, s) {   // four-point star
      var k = s*.3;
      ctx.beginPath(); ctx.moveTo(x, y - s);
      ctx.quadraticCurveTo(x + k, y - k, x + s, y); ctx.quadraticCurveTo(x + k, y + k, x, y + s);
      ctx.quadraticCurveTo(x - k, y + k, x - s, y); ctx.quadraticCurveTo(x - k, y - k, x, y - s);
      ctx.fill();
    }
    // each mote fades in, rises with an ease-in-out, drifts sideways, shrinks and fades, then restarts somewhere new
    function frame(now) {
      var t = now / 1000, sy = window.scrollY;
      ctx.clearRect(0, 0, cv.width, cv.height);
      for (var j = 0; j < motes.length; j++) {
        var m = motes[j], time = t + m.off, cyc = Math.floor(time / m.dur), u = reduced ? .45 : time / m.dur - cyc;
        var x0 = hash(m.i + 7, cyc)*W, y0 = H*(.3 + hash(m.i + 13, cyc)*.85), rise = H*(.55 + hash(m.i + 29, cyc)*.35);
        var e = u < .5 ? 2*u*u : 1 - Math.pow(-2*u + 2, 2)/2;
        var y = y0 - rise*e - (reduced ? 0 : sy*m.p);
        y = ((y + 30) % (H + 60) + (H + 60)) % (H + 60) - 30;
        var x = x0 + m.drift*e + (reduced ? 0 : Math.sin(t*.7 + m.ph)*5);
        var a = u < .12 ? u/.12*.9 : u < .5 ? .9 - (u-.12)/.38*.2 : u < .85 ? .7 - (u-.5)/.35*.3 : .4*(1 - (u-.85)/.15);
        var sc = u < .5 ? .5 + u : 1 - (u-.5)*1.2;
        if (a <= .01) continue;
        var c = m.c, X = x*DPR, Y = y*DPR;
        if (m.star) {
          ctx.fillStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + (a*.9) + ')';
          sparkle(X, Y, (3 + m.size*4)*sc*DPR);
        } else {
          var rad = (1 + m.size*1.8)*sc*DPR;
          ctx.fillStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + (a*.16) + ')';   // soft glow
          ctx.beginPath(); ctx.arc(X, Y, rad*3, 0, TAU); ctx.fill();
          ctx.fillStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')';
          ctx.beginPath(); ctx.arc(X, Y, rad, 0, TAU); ctx.fill();
        }
      }
      if (!reduced) requestAnimationFrame(frame);
    }

    resize();
    addEventListener('resize', function () { resize(); if (reduced) frame(0); });
    requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
